import type { GamificationLevel, GamificationProfile } from '../../types/auth';

export type HomeLightPathRenderState = 'hidden' | 'guest' | 'loading' | 'personal' | 'error';

export interface HomeLightPathStateInput {
  sectionEnabled: boolean;
  authLoading: boolean;
  isAuthenticated: boolean;
  isParticipant: boolean;
  profileLoading: boolean;
  profileReadyForUser: boolean;
  profile: GamificationProfile | null;
  profileError: string | null;
}

export function resolveHomeLightPathState(input: HomeLightPathStateInput): HomeLightPathRenderState {
  if (!input.sectionEnabled) return 'hidden';
  if (input.authLoading) return 'loading';
  if (!input.isAuthenticated) return 'guest';
  if (!input.isParticipant) return 'hidden';
  if (input.profileLoading || !input.profileReadyForUser) return 'loading';
  if (input.profileError) return 'error';
  if (input.profile) return 'personal';
  return 'error';
}

export function levelProgressFraction(level: GamificationLevel): number | null {
  if (typeof level.xpIntoLevel !== 'number') return null;
  if (typeof level.xpForNextLevel !== 'number' || level.xpForNextLevel <= 0) return null;
  const span = level.xpIntoLevel + level.xpForNextLevel;
  if (span <= 0) return null;
  return Math.max(0, Math.min(1, level.xpIntoLevel / span));
}
